import { useMemo } from "react";

import { composeErrorHandlers, ErrorHandler } from "../../utils/errorHandling";

import { useAuthErrorHandlerCreator } from "./useAuthErrorHandler";
import useNotFoundHandlerCreator from "./useNotFoundHandlerCreator";

const useSWRApiErrorHandler = (): ErrorHandler => {
    const onAuthErrorHandler = useAuthErrorHandlerCreator();
    const onNotFoundHandler = useNotFoundHandlerCreator();
    return useMemo(
        () => composeErrorHandlers(onNotFoundHandler, onAuthErrorHandler),
        [onNotFoundHandler, onAuthErrorHandler],
    );
};

export default useSWRApiErrorHandler;
